import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
import '@backstage/ui/css/styles.css';
// Must come after BUI's own stylesheet so the Clearistic tokens win.
import './themes/clearistic-bui.css';


ReactDOM.createRoot(document.getElementById('root')!).render(app);
